import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

export type UserRole = "system_admin" | "org-admin" | "teacher" | "learner" | null;

// email は CSV 登録の学習者では返らないことがある（ログイン ID で入る人）
export type User = {
  id: number;
  name: string;
  email?: string | null;
  login_id?: string | null;
  role?: UserRole;
  org_id?: number | null;
};

type AuthState = {
  accessToken: string | null;
  user: User | null;
  setAuth: (accessToken: string, user: User) => void;
  setAccess: (accessToken: string) => void;
  clear: () => void;
};

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      accessToken: null,
      user: null,
      setAuth: (accessToken, user) => set({ accessToken, user }),
      setAccess: (accessToken) => set({ accessToken }),
      clear: () => set({ accessToken: null, user: null }),
    }),
    {
      name: "nihongo-learner-auth",
      storage: createJSONStorage(() => localStorage),
      partialize: (s) => ({ accessToken: s.accessToken, user: s.user }),
    }
  )
);
